import { useAppSelector } from '@/redux';
import { Store } from '@whiz-cart/node-shared/models/store';
import { useMemo } from 'react';

export function useStores() {
    return useAppSelector((state) => state.stores);
}

export function useStoresList(): Store[] {
    const stores = useAppSelector((state) => state.stores.stores);
    return useMemo(() => Object.values(stores ?? {}), [stores]);
}
